import styled from 'styled-components';
import { Menu as MenuPlasma } from '@sms/plasma-ui';
import { ColorPalette } from '@sms/journal-commons-journal-commons-ui';

export const Menu = styled(MenuPlasma)`
  background-color: ${ColorPalette.WHITE};
  border-bottom: 1px solid ${ColorPalette.LIGHT_GRAY};

  .ant-menu-item {
    margin: 0 !important;
    padding: 0 16px !important;
    position: unset;
    padding: 0 16px;

    &:hover {
      color: unset !important;
      border-bottom: 2px solid transparent !important;
    }

    &.ant-menu-item-selected {
      background-color: ${ColorPalette.WHITE};
      color: ${ColorPalette.TEXT_PRIMARY} !important;
      border-bottom: 2px solid ${ColorPalette.WHITE};

      &,
      &:hover {
        color: ${ColorPalette.TEXT_PRIMARY} !important;
        border-bottom: 2px solid ${ColorPalette.WHITE};
      }
    }
  }
`;

export const MenuItem = styled(MenuPlasma.Item)`
  font-size: 14px;

  span,
  svg {
    color: inherit;
  }

  > div[class^='Icon'] {
    svg {
      font-size: 16px;
      margin-right: 8px;
    }
  }
`;


export const BookMenu = styled(MenuPlasma.Item)`
  font-size: 16px;

  span,
  svg {
    color: inherit;
  }

  > div[class^='Icon'] {
    svg {
      font-size: 16px;
      margin-right: 8px;
    }
  }

  .book-icon {
    margin-left: 16px !important;
  }

  > span[class*='Tooltip']{
    font-size: 16px;
  }
`;

export const SettingsMenu = styled(MenuPlasma.Item)`
  font-size: 14px;
  position: absolute !important;
  right: 0 !important;
  justify-content: center !important;
  align-items: center !important;

  span,
  svg {
    color: inherit;
  }

  > div[class^='Icon'] {
    svg {
      font-size: 16px;
      margin-right: 8px;
    }
  }
`;

export const SettingsWrapper = styled.div`
  background-color: ${ColorPalette.WHITE} !important;
  height: 47px;

  > button {
    margin-left: 16px;
    top: 7px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
